module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAJCAYAAAARml2dAAAAZUlEQVQImV3MIQ7CQBRF0UODRrCFurKA+hoEgqS7wLCcsgvUmKpKEvxIllBVi6iaZPKfvCd5h5TShCf+qjV4YMY5Agz4oosALT64RYAT3rhE2DAiH6v4wx25vlrQl1jghSvW+nMHvfwQZ3dzaW4AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/common/images/pp1.png
// module id = cj+C
// module chunks = 20